// import { AngularFirestore } from '@angular/fire/firestore';
import { Router } from '@angular/router';
// import { AngularFireAuth } from '@angular/fire/auth';
import { CartService } from './../../services/cart.service';
import { Component, OnInit, ViewChild } from '@angular/core';
import { first } from 'rxjs/operators';
import { Location } from '@angular/common';
import * as  firebase from 'firebase';
import { ModalDirective } from 'ng-uikit-pro-standard';
import { UserService } from './../../services/user.service';

@Component({
  selector: 'app-cart',
  templateUrl: './cart.component.html',
  styleUrls: ['./cart.component.scss']
})
export class CartComponent implements OnInit {

  @ViewChild('frame', {static: true}) frame: ModalDirective;
  @ViewChild('error', {static: true}) error: ModalDirective;

  public user: any;
  public carts: any;
  public totalAmount: number;
  public total : number = 0;
  public items : any  ;
  public person: any;
  error_response;
  public newCustomer: any;
  public hidebutton: boolean =true;
  public sumAll: any;
  public totalPrice: number = 0;
  public totalQuantity: number = 0;
  public sum: number = 0;
  public productItem: any;
  public my_button: boolean = true;
  public email: string;
  public password: string;
  response; mycarts;
  public cpassword: string;
  public fullname: string;
  public phone: string

  constructor(
    public cs: CartService,
    private location: Location,
    public router: Router,
    public us: UserService
  ) { }

  ngOnInit():void {
    this.user = JSON.parse(localStorage.getItem('user_details'));
    console.log(this.user);

      this.cs.getItemsFromCart().then(ref=>{
        ref.subscribe(res => {
          this.mycarts = res;
          this.carts = this.mycarts.data
          console.log(this.carts)
          
          this.carts.forEach((item: any) => {
            this.productItem = item
  
          // Get the total qty of a product added 
            this.totalQuantity += Number(this.productItem.quantity);
  
           // Get the total price of all products in carts i.e Product price x quantity
            this.total += Number(Number(this.productItem.product.price) * Number(this.productItem.quantity))
            console.log(this.total)
            })
        })
      },
        async error => {
          console.log(await error)
          this.error_response = await error;
          console.log(this.error_response)
        }
      )
  }

  async getTotal(carts){
    await carts.forEach(async cart => {
      this.totalPrice += await Number(cart.product.price)
      console.log(await this.totalPrice)
    });
  }

  goBack() {
    this.location.back(); // <-- go back to previous location on cancel
  }

  async removeCart(){
    await this.cs.deleteCart().then(ref => {
        ref.subscribe(res=>{
          console.log(res)
        },
        error => {
          console.log(error)
        }
      )
    })
    await this.reloadPage()
  }

  reloadPage() {
    setTimeout(()=>{
      window.location.reload();
    }, 100);
}

  changePrice(id, quantity){  
 
  }

  async checkOut(carts){
    const cart_items = await []
    for(let i = 0; i < await carts.length; i++){
      await cart_items.push(await carts[i].id)
    }
    console.log(await cart_items)
  }
}
